import { render } from "./GroomingCard.vue?vue&type=template&id=595af203&scoped=true"
import script from "./GroomingCard.vue?vue&type=script&lang=js"
export * from "./GroomingCard.vue?vue&type=script&lang=js"

import "./GroomingCard.vue?vue&type=style&index=0&id=595af203&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595af203"]])

export default __exports__